// extracted by mini-css-extract-plugin
export default {"new-diary-form":"NewDiaryItem_new-diary-form__C6aX7","show-diary-form":"NewDiaryItem_show-diary-form__uX3r4"};